import { HttpClient } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WorkFlowService {
  workFlowUrl: string = Constants.WORKFLOW_API_URL;
  o3CorebaseUrl: string = Constants.CORE_API_BASE_URL;
  constructor(private http: HttpClient) { }
  // work flow api routes
  getWorkFlow(key: any): Observable<any> {
    return this.http.post<any>(
      this.workFlowUrl + 'WorkFlow/getWorkFlowByScreenName',
      key
    );
  }

  createBulkInstances(data: any): Observable<any> {
    return this.http.post<any>(
      this.workFlowUrl + 'Instance/createBulkInstances',
      data
    );
  }
  createSingleInstances(data: any): Observable<any> {
    return this.http.post<any>(
      this.workFlowUrl + 'Instance/createInstance',
      data
    );
  }
  setBulkInstance(data: any): Observable<any> {
    return this.http.post<any>(
      this.workFlowUrl + 'Instance/setBulkInstance',
      data
    );
  }
  setSingleInstance(data: any): Observable<any> {
    return this.http.post<any>(this.workFlowUrl + 'Instance/setInstance', data);
  }

  setNCRInstanceKey(data: any): Observable<any> {
    return this.http.post<any>(
      this.o3CorebaseUrl + 'NCR/SetNCRInstanceKey',
      data
    );
  }
  getInstanceCurrentState(key: string): Observable<any> {
    return this.http.get<any>(
      this.workFlowUrl + 'Instance/getCurrentInstanceState/' + key
    );
  }
  getWorkflowStatuses(key: any): Observable<any> {
    return this.http.get<any>(
      this.workFlowUrl + `WorkFlow/getWorkFlowStates/${key}`
    );
  }
  deleteBulkInstances(data: string[]): Observable<any> {
    return this.http.post<any>(
      this.workFlowUrl + 'Instance/deleteBulkInstance',
      data
    );
  }
  discardInstance(key: any): Observable<any> {
    return this.http.post<any>(
      this.workFlowUrl + 'Instance/discardInstance',
      key
    );
  }
  getWorkFlowPermission(keys: any): Observable<any> {
    return this.http.post<any>(
      this.workFlowUrl + 'Instance/getUserPermission',
      keys
    );
  }

  resetWorkflowInstanceHeirarchy(data): Observable<any> {
    return this.http.post<any>(
      this.workFlowUrl + 'WorkFlow/ResetWorkflowInstanceHeirarchy',
      data
    );
  }

  updateInstance(data: any): Observable<any> {
    return this.http.post<any>(this.workFlowUrl + 'Instance/updateInstance', data);
  }

  getInstanceCurrentStateByNCR(key: any): Observable<any> {
    return this.http.post<any>(
      this.workFlowUrl + 'Instance/getCurrentInstanceStateByNCR', key
    );
  }

  getUserPermissionByTransition(data: any): Observable<any> {
    return this.http.post<any>(
      this.workFlowUrl + 'Instance/getUserPermissionByTransition',
      data
    )
  }
}
